import { useCallback, useEffect, useRef } from 'react';

export const useBoardInput = ({ phase, onMove, onReset }) => {
  const gestureStartRef = useRef(null);

  const handlePointerStart = useCallback(
    (event) => {
      if (phase !== 'game') return;
      gestureStartRef.current = { x: event.clientX, y: event.clientY, id: event.pointerId };
    },
    [phase]
  );

  const handlePointerEnd = useCallback(
    (event) => {
      const start = gestureStartRef.current;
      if (!start) return;
      if (start.id !== undefined && event.pointerId !== undefined && start.id !== event.pointerId) return;
      gestureStartRef.current = null;

      const dx = event.clientX - start.x;
      const dy = event.clientY - start.y;
      const absX = Math.abs(dx);
      const absY = Math.abs(dy);
      const travel = Math.max(absX, absY);
      if (travel < 16) return;

      const direction = absX > absY ? (dx > 0 ? 'right' : 'left') : (dy > 0 ? 'down' : 'up');
      onMove(direction);
    },
    [onMove]
  );

  const handlePointerCancel = useCallback(() => {
    gestureStartRef.current = null;
  }, []);

  useEffect(() => {
    const keyHandler = (event) => {
      if (phase !== 'game') return;
      const map = {
        ArrowLeft: 'left',
        ArrowRight: 'right',
        ArrowUp: 'up',
        ArrowDown: 'down',
        a: 'left',
        d: 'right',
        w: 'up',
        s: 'down',
      };

      const direction = map[event.key];
      if (direction) {
        event.preventDefault();
        onMove(direction);
      } else if (event.key.toLowerCase() === 'r' && onReset) {
        onReset();
      }
    };

    window.addEventListener('keydown', keyHandler);
    return () => window.removeEventListener('keydown', keyHandler);
  }, [onMove, onReset, phase]);

  return { handlePointerStart, handlePointerEnd, handlePointerCancel };
};
